<template>
  <div class="importDiv">
    <v-dialog v-model="importDialog" persistent max-width="40%">
      <v-card>
        <v-card-title class="primary">
          <span class="white--text" style="width: 100%">
            Import Report
            <v-btn class="primary lighten-1 float-right" dark icon @click="$emit('close'); reset()">
              <v-icon color="white--text">mdi-close</v-icon>
            </v-btn>
          </span>
        </v-card-title>
        <v-card-text class="pt-5">
          <v-container>
            <v-form enctype="multipart/form-data">
              <v-file-input
                data-cy="fileUpload"
                color="primary"
                class="d-flex mr-2"
                counter
                label="File input"
                multiple
                placeholder="Select your files"
                prepend-icon="mdi-paperclip"
                outlined
                type="file"
                :show-size="1000"
                ref="files"
                v-model="files"
                @click:clear="reset()"
                :success="success"
                :error="error"
                :success-messages="successMsg"
                :error-messages="errorMsg"
              >
                <template v-slot:selection="{ index, text }">
                  <v-chip v-if="index < 5" color="primary" dark label small>{{ text }}</v-chip>
                </template>
              </v-file-input>

              <div class="justify-end d-flex mt-5">
                <span>
                  Download the CSV version of the report 'Financial->Aged Receivables by Trandate'
                </span>
                <v-btn
                  class="primary"
                  data-cy="import"
                  :disabled="success || this.files == 0"
                  :loading="dialog"
                  @click="dialogActive=!dialogActive;"
                >Import</v-btn>
                <v-dialog v-model="dialog" persistent width="300">
                  <v-card color="primary" dark>
                    <v-card-text class="pt-3 white--text">
                      Please stand by
                      <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
                    </v-card-text>
                  </v-card>
                </v-dialog>
                <app-dialog
                  :dialogActive="dialogActive"
                  @proceed="save"
                  @cancel="cancel"
                  :message="'Are you sure you want to import uploaded files?'"
                ></app-dialog>
              </div>
            </v-form>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import AppDialog from '@/components/dialogs/AppDialog';
import { mapActions } from 'vuex';

export default {
  components: {
    AppDialog
  },
  props: {
    importDialog: { type: Boolean }
  },
  data () {
    return {
      dialogActive: false,
      message: '',
      uploadError: null,
      currentStatus: null,
      fileCount: 0,
      files: [],
      success: false,
      error: false,
      dialog: false,

    }
  },
  methods: {
    ...mapActions('reminders', ['updateUploadsOnOrder', 'processReminders', 'getReminders']),
    cancel () {
      this.dialogActive = false;
    },
    proceed () {
      this.dialogActive = false;
    },
    save () {
      let vm = this;
      let formData = new FormData();
      vm.dialog = true;
      vm.$refs.files.value.forEach(x =>
        formData.append('files', x))

      vm.processReminders(formData)
        .then(data => {
          if (data.length != 0) {
            setTimeout(() => {
              vm.dialog = false;
              vm.success = true;
              vm.getReminders({ showExcluded: false, stage: "none" });
              this.$emit('import');
            }, 1000);

          } else {
            vm.error = true;
          }
        })
        .catch(err => {
          vm.uploadError = err.response;
        });
      vm.dialogActive = false;
    },
    reset () {
      this.success = false;
      this.error = false;
      this.files = [];
      this.bnrdisplay = false;
    }
  },
  computed: {
    successMsg () {
      return this.success ? ['File successfully imported'] : []
    },
    errorMsg () {
      return this.error ? ['Failed to import file'] : []
    }
  }
}
</script>

<style lang="scss" scoped>
.importDiv {
  width: 100%;
}
.color {
  color: #2f5578;
}
</style>
